import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ArrowPathIcon, BellAlertIcon, BellIcon, HomeIcon, } from "@heroicons/react/24/outline";
import { useContext } from "@wordpress/element";
import { useNavigate } from "react-router-dom";
import { LoadingOval } from "../../../components/Loading/Loading";
import { UserPageNotificationsContext } from "../../providers/UserPageNotificationsContextProvider";
import { ProfileDropdown } from "../Dropdown/ProfileDropdown/ProfileDropdown";
function NavigationBar({ loading, onRefresh = () => { } }) {
    const navigate = useNavigate();
    const { checkNewComments } = useContext(UserPageNotificationsContext);
    const refresh = () => {
        onRefresh();
        checkNewComments();
    };
    return (_jsxs("div", { className: "wpqt-grid wpqt-h-[60px] wpqt-grid-cols-[1fr_auto_1fr] wpqt-items-center wpqt-border-0 wpqt-border-t wpqt-border-solid wpqt-border-y-gray-300 wpqt-px-4 wpqt-py-2 lg:wpqt-border-b lg:wpqt-border-t-0", children: [_jsx("div", { className: "wpqt-flex wpqt-gap-2", children: _jsx(HomeIcon, { onClick: () => navigate("/"), className: "wpqt-size-8 wpqt-cursor-pointer" }) }), _jsx("div", { className: "wpqt-text-center", children: loading ? (_jsx(LoadingOval, { width: "30", height: "30" })) : (_jsx(ArrowPathIcon, { className: "wpqt-icon-blue wpqt-size-9 wpqt-cursor-pointer hover:wpqt-text-qtBlueHover", onClick: refresh })) }), _jsxs("div", { className: "wpqt-flex wpqt-items-center wpqt-justify-end wpqt-gap-3", children: [_jsx(NotificationIcon, {}), _jsx(ProfileDropdown, {})] })] }));
}
function NotificationIcon() {
    const navigate = useNavigate();
    const { state: { newComments }, } = useContext(UserPageNotificationsContext);
    return (_jsx(_Fragment, { children: newComments.length > 0 ? (_jsx(BellAlertIcon, { className: "wpqt-icon-red wpqt-size-7 wpqt-animate-bellShake wpqt-cursor-pointer", onClick: () => {
                navigate("/notifications");
            } })) : (_jsx(BellIcon, { className: "wpqt-icon-gray wpqt-size-7 wpqt-cursor-pointer", onClick: () => {
                navigate("/notifications");
            } })) }));
}
export { NavigationBar };
